import React from 'react'
import { ToggleButton } from '@s4l/ds'
import { IconHeartFull } from '@s4l/icons/IconHeartFull'
import { IconHeartVoid } from '@s4l/icons/IconHeartVoid'

interface IActionLikeUnlikeProps {
  isLiked: boolean
  onClick: () => void
}

export const ActionLikeUnlike = ({ onClick, isLiked }: IActionLikeUnlikeProps) => {
  return (
    <ToggleButton
      iconOnActive={<IconHeartFull />}
      iconOnInactive={<IconHeartVoid />}
      activeColor="var(--color-primary-500)"
      animation="heartbeat"
      size="extraSmall"
      onClick={onClick}
      onMouseDown={(e: React.MouseEvent) => e.stopPropagation()}
      value={isLiked}
      data-testid="action-like-unlike"
    />
  )
}
